<template>
  <div class="page-steps">
    <el-steps direction="vertical" :active="current">
      <el-step v-for="(step, index) in data" :key="step.id">
        <div slot="title">
          <span>{{ step.name }}</span>
          <i class="check el-icon-circle-check"></i>
        </div>

        <ul slot="description">
          <li @click="onDescClick(index, _index)" :class="{ hasContent: !!t.name }" v-for="(t, _index) in step.children" :key="t.id">
            <span>{{ t.name }}</span>
          </li>
        </ul>
      </el-step>
    </el-steps>
  </div>
</template>
<script>
export default {
  name: 'Steper',
  props: {
    current: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      required: true
    }
  },
  computed: {},
  methods: {
    onDescClick(curr, descIndex) {
      // 只有当前step能点击进行模拟锚点滚动
      if (this.current === curr) {
        const modulers = Array.from(document.querySelectorAll('.c-moduler'))
        modulers[descIndex]?.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-steps {
  ::v-deep .el-step__title {
    padding-bottom: 16px;
    .check {
      visibility: hidden;
      margin-left: 8px;
    }
    &.is-finish {
      .check {
        visibility: visible;
      }
    }
  }

  ::v-deep .el-step__description {
    margin-top: 0;
    &.is-process {
      li {
        cursor: pointer;
      }
    }
    li {
      padding: 0 0 16px 12px;
      line-height: 1.2;
      display: none;

      &.hasContent {
        display: block;
      }
    }
  }
}
</style>
